// extracted by mini-css-extract-plugin
module.exports = {"menuItems":"menuseccio_menuItems__qZ_gT","link":"menuseccio_link__hNcPk","active":"menuseccio_active__7ObfD","contentHidden":"menuseccio_contentHidden__uJGFN"};